const mapElement = document.getElementById("scaib-map");
const latitude = "51.18489609773778";
const longitude = "-0.981472769308723";

mapboxgl.accessToken =
  "pk.eyJ1IjoiaGFtaWx0b25icm9va2UiLCJhIjoiY20zNzg4OWZiMDl3NTJsczVobXM2aG9payJ9.C3Ffrc8jMMTW4hit7PQdzQ";
const map = new mapboxgl.Map({
  container: "scaib-map",
  style: "mapbox://styles/mapbox/streets-v11",
  center: [longitude, latitude],
  zoom: 14,
});

const svgMarker = document.createElement("div");
svgMarker.innerHTML = `
  <svg width="42" height="64" viewBox="0 0 42 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.33,64c1.28-21.3,19.67-26.7,19.67-42.7,0-5.9-2.36-11.2-6.2-15.1-3.74-3.8-8.95-6.2-14.75-6.2S10.03,2.4,6.2,6.2C2.36,10.1,0,15.4,0,21.3c0,16,18.39,21.3,19.67,42.7h2.66Z" fill="#003a57"/><path d="M33.89,28.39c-.19,0-.19.19-.28.28-.19.47-.47,1.32-.94,1.79-.94.94-2.07,1.04-3.95,1.04-4.99,0-8.47-3.76-8.47-8.09,0-2.26.28-4.33,2.07-5.84.75-.75,2.26-1.69,5.27-1.69,2.07,0,3.76.56,4.52,1.22.75.56,1.22,1.51,1.22,2.26,0,.28,0,.47.19.47s.19-.19.28-.47c.19-.28,0-1.69,0-2.26,0-.75.19-1.04.19-1.22s0-.28-.28-.28c-.75,0-1.51-.19-2.45-.28-1.22-.19-2.54-.28-3.48-.28-3.58,0-5.74,1.04-7.06,2.45-1.69,1.51-2.26,3.48-2.54,4.99-.56-.94-1.69-1.79-3.2-3.01l-.94-.75c-2.82-2.26-3.76-3.29-3.76-5.08,0-2.26,1.69-3.58,3.76-3.58,2.82,0,3.58,1.22,3.95,1.69.19.28.28,1.22.47,1.51,0,.28,0,.47.28.47.19,0,.19-.28.19-.75,0-2.07.19-3.2.19-3.29s0-.19-.28-.19-.47,0-1.04-.19c-.94-.19-1.79-.28-3.01-.28-3.95,0-6.31,2.26-6.31,5.55,0,2.07.75,4.05,4.05,6.59l1.32,1.04c2.73,2.07,3.58,3.29,3.58,5.46,0,1.98-1.51,4.05-4.33,4.05-2.07,0-4.05-.94-4.52-3.2-.19-.47-.19-.94-.19-1.22s0-.28-.19-.28-.19.19-.28.47c0,.56-.19,1.79-.19,3.29,0,.75,0,.94.47,1.22,1.22.94,2.54,1.04,4.05,1.04,1.69,0,3.29-.47,4.71-1.32,1.32-.94,1.98-2.26,2.45-3.29.47.75,1.04,1.51,1.79,2.07,1.79,1.69,4.24,2.45,7.72,2.45,1.51,0,3.29-.19,4.24-.56.47-.19.47-.28.56-.56.28-.75.56-2.73.56-2.82-.09-.38-.19-.56-.38-.56Z" fill="#fff"/>
  </svg>
`;
svgMarker.style.width = "42px";
svgMarker.style.height = "64px";

new mapboxgl.Marker(svgMarker, { anchor: "bottom" })
  .setLngLat([longitude, latitude])
  .addTo(map);
